export default __webpack_public_path__ + "static/media/my-shop-ss.17d5a0f5.png";